export default __webpack_public_path__ + "static/placeholder-white-5cafa8af5efe0bf5b319fc376b83dbf9.jpg";